(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvorite-product-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nv-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-nv-tab]');
    const panels = tabs.querySelectorAll('[data-nv-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.nvTab;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.nvPanel !== target; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
